var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Search = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M1.76 9.24A7.54 7.54 0 0 1 9.3 1.7a7.5 7.5 0 0 1 7.53 7.53 7.54 7.54 0 0 1-7.53 7.52 7.5 7.5 0 0 1-7.53-7.52ZM0 9.24a9.26 9.26 0 0 0 9.3 9.23c2 0 3.88-.65 5.4-1.7L17.54 20l1.3-1.12L16 15.65a9.14 9.14 0 0 0 2.59-6.36A9.29 9.29 0 0 0 9.29 0 9.26 9.26 0 0 0 0 9.24Z" }))); });
//# sourceMappingURL=Search.js.map